export const baseData = {
  title: "PRODUCT CATEGORY"
}